export const iconFontAwesomeMoneyMoneyBill1Wave = (
	<i className="fa-solid fa-money-bill-1-wave"></i>
);
